import { Grid, Typography, Box, TextField, IconButton, InputAdornment, Checkbox, FormControlLabel, Link, Button, CircularProgress, } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from 'yup';
import styleCss from "../Style/style";
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { AuthLogin } from "../ReduxStore/authSlice";
import { useDispatch } from "react-redux";
import showToast from "../Utilities/showToast";
import { useNavigate } from "react-router-dom";




export const EmailLogin = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const handleToggle = () => setShowPassword(!showPassword);
    const emailFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email("Enter the proper email id")
                .required("Enter the email id"),
            password: Yup.string()
                .required("Enter the password")
        }),
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: async (values) => {
            setLoading(true)
            const { payload: response } = await dispatch(AuthLogin({
                ...values, login_type: "1"
            }))
            setLoading(false)
            if (response.status) {
                showToast('success', response.message)
                navigate('/')
            } else {
                showToast('error', response.message)
            }
        }
    });
    return (
        <Box>
            <form onSubmit={emailFormik.handleSubmit}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography sx={styleCss.CommonLabelName}>Email id</Typography>
                        <TextField
                            name="email"
                            onChange={emailFormik.handleChange}
                            value={emailFormik.values.email}
                            error={emailFormik.touched.email && Boolean(emailFormik.errors.email)}
                            variant="outlined"
                            size="small"
                            placeholder="Enter your email"
                            fullWidth
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#f3f3f5",
                                    borderRadius: "8px",
                                    minHeight: "32px",
                                    padding: 0,
                                    "& input": {
                                        padding: "12px 10px",
                                        fontSize: "13px",
                                        "&::placeholder": {
                                            fontSize: "13px",
                                            color: "#717182",
                                            opacity: 1,
                                            fontFamily: "Segoe UI",
                                        },
                                    },
                                    "& fieldset": { borderColor: "#ddd" },
                                    "&:hover fieldset": { borderColor: "#bbb" },
                                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                    fontFamily: "Segoe UI",
                                    fontSize: "14px",
                                    color: "#364252",
                                },
                            }}
                        />
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography sx={styleCss.CommonLabelName}>Password</Typography>
                        <TextField
                            name="password"
                            onChange={emailFormik.handleChange}
                            value={emailFormik.values.password}
                            error={emailFormik.touched.password && Boolean(emailFormik.errors.password)}
                            variant="outlined"
                            size="small"
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter your password"
                            fullWidth
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#f3f3f5",
                                    borderRadius: "8px",
                                    minHeight: "32px",
                                    padding: 0,
                                    "& input": {
                                        padding: "12px 10px",
                                        fontSize: "13px",
                                        "&::placeholder": {
                                            fontSize: "13px",
                                            color: "#717182",
                                            opacity: 1,
                                            fontFamily: "Segoe UI",
                                        },
                                    },
                                    "& fieldset": { borderColor: "#ddd" },
                                    "&:hover fieldset": { borderColor: "#bbb" },
                                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                    fontFamily: "Segoe UI",
                                    fontSize: "14px",
                                    color: "#364252",
                                },
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleToggle} edge="end" sx={{ marginRight: 'unset' }}>
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid size={{ md: 6, xs: 6 }}>
                        <FormControlLabel
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontFamily: "Segoe UI",
                            }}
                            control={
                                <Checkbox
                                    sx={{
                                        color: "#1d3557",
                                        "&.Mui-checked": { color: "#1d3557" },
                                        padding: "0px 0px 0px 10px",
                                    }}
                                />
                            }
                            label={
                                <Typography
                                    component="span"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "3px",
                                        fontFamily: "Segoe UI",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "#030213",
                                        whiteSpace: "nowrap",
                                        cursor: "pointer",
                                    }}
                                >
                                    Remember me
                                </Typography>
                            }
                        />
                    </Grid>
                    <Grid size={{ md: 6, xs: 6 }} sx={{ textAlign: "right" }}>
                        <Link
                            to="/"
                            style={{
                                fontSize: "15px",
                                fontWeight: "normal",
                                color: "#ff5714",
                                fontFamily: "Segoe UI",
                                textDecoration: "none",
                                display: "inline-block",
                                textAlign: "right",
                            }}
                        >
                            Forgot Password?
                        </Link>
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Button type="submit" variant="contained" sx={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 100px 0 rgba(0, 0, 0, 0.08)",
                            backgroundColor: "#ff5714",
                            fontFamily: "Segoe UI",
                            fontSize: "15px",
                            fontWeight: "500",
                            fontStretch: "normal",
                            fontStyle: "normal",
                            lineHeight: "normal",
                            letterSpacing: "normal",
                            textAlign: "left",
                            color: "#fff",
                            textTransform: "none",
                            width: '100%',
                            padding: '10px 16px',
                            "&:hover": {
                                backgroundColor: "#e64e12",
                                boxShadow: "0 6px 120px 0 rgba(0, 0, 0, 0.12)",
                            },
                        }}> {loading ? (
                            <CircularProgress size={20} color="inherit" />
                        ) : (
                            "Login"
                        )}</Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}